import { APPOINTMENT_REQUEST_PAST, APPOINTMENT_REQUEST_PAST_ERROR, APPOINTMENT_REQUEST_PAST_SUCCESS, APPOINTMENT_REQUEST_TODAY, APPOINTMENT_REQUEST_TODAY_ERROR, APPOINTMENT_REQUEST_TODAY_SUCCESS, APPOINTMENT_REQUEST_UPCOMING, APPOINTMENT_REQUEST_UPCOMING_ERROR, APPOINTMENT_REQUEST_UPCOMING_SUCCESS } from './Constant';

export const todayAppointmentsRequest = (page) => ({
    type: APPOINTMENT_REQUEST_TODAY,
    page : page
});

export const todayAppointmentsRequestSuccess = (payload) => ({
    type: APPOINTMENT_REQUEST_TODAY_SUCCESS,
    payload : payload
});

export const todayAppointmentsRequestError = () => ({
    type: APPOINTMENT_REQUEST_TODAY_ERROR,
});

export const upComingAppointmentsRequest = (page) => ({
    type: APPOINTMENT_REQUEST_UPCOMING,
    page : page
});

export const upComingAppointmentsRequestSuccess = (payload) => ({
    type: APPOINTMENT_REQUEST_UPCOMING_SUCCESS,
    payload : payload
});

export const upComingAppointmentsRequestError = () => ({
    type: APPOINTMENT_REQUEST_UPCOMING_ERROR,
});

export const pastAppointmentsRequest = (page) => ({
    type: APPOINTMENT_REQUEST_PAST,
    page : page
});

export const pastAppointmentsRequestSuccess = (payload) => ({
    type: APPOINTMENT_REQUEST_PAST_SUCCESS,
    payload : payload
});

export const pastAppointmentsRequestError = () => ({
    type: APPOINTMENT_REQUEST_PAST_ERROR,
});